export { appStateAdapter } from '@/adapters/appState/appStateAdapter';
export type { AppStateAdapter, AppStateStatus } from '@/adapters/appState/types';
